<script>
    import { changeData } from '@/scripts/tools.js';

    export default {
        computed: {
            editData() {return this.$store.getters.FILTER_ITEM_DATA_EDIT},
        },
        data() {
            return {
                errorText: '',
            }
        },
        methods: {
            async updateData(event, fieldName, isCheckBox = false) {
                this.errorText = await changeData(
                    event, fieldName, 'FILTER_ITEM_DATA_EDIT_UPDATE', 'CHECK_FILTER_ITEM_EDIT', isCheckBox
                );
            },
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input 
            :value="editData['name']"
            @change="updateData($event, 'name')"
            class="right_input mt_5 mb_10"
            type="text"
        >

        <label>
            <input 
                :checked="editData['is_default']"
                @change="updateData($event, 'is_default', true)"
                type="checkbox"
            >
            Default
        </label>

        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>